import { z } from 'zod';

/**
 * 申請回数 登録/編集 フォーム用 Zod schema.
 * rezept_yearmonth_str は RA2NDatePicker (picker="month") の和暦表記 (例: 令和07年05月)。
 * submit 時に YYYYMM に変換して API に渡す。
 * rezept_application_count / rezept_related_application_count は文字列で受け取り、
 * バリデーション後に数値に変換する（InputNumber の自動変換を避けるため）。
 */

const integerCountField = (label: string) =>
  z
    .string()
    .refine(
      v => v.trim() === '' || /^-?\d+$/.test(v.trim()),
      `${label}は整数にしてください。`,
    )
    .refine(
      v => {
        const trimmed = v.trim();
        if (trimmed === '') return true;
        return Number(trimmed) >= 0;
      },
      `${label}は0以上にしてください。`,
    );

export const rezeptApplicationCountFormSchema = z.object({
  rezept_yearmonth_str: z
    .string()
    .min(1, '施術年月は必須です。')
    .regex(
      /^(明治|大正|昭和|平成|令和)\d{2}年\d{2}月$/,
      '施術年月を正しく入力してください。'
    ),
  rezept_application_count: integerCountField('医療費最終申請回数'),
  rezept_related_application_count: integerCountField('助成費最終申請回数'),
});

/** Input type = Output type (all strings, transform happens in onSubmit) */
export type RezeptApplicationCountFormInput = z.infer<
  typeof rezeptApplicationCountFormSchema
>;
